angular.module('SpidApp')

.factory('StockService',
		['Stock', 'Restangular',
function (Stock,   Restangular) {
	var StockService = {
		
		// GET: /agencies/{agency_id}/stocks/{stock_id}
		findByAgencyIdAndStockId: function (agencyId, stockId) {
			if (!agencyId || !stockId) {
				throw 'StockService::findByAgencyIdAndStockId() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).one('stocks', stockId).get().then(function (data) {
				return new Stock(data)
			})
		},
		
		// GET: /agencies/{agency_id}/stocks
		findByAgencyId: function (agencyId) {
			if (!agencyId) {
				throw 'StockService::findByAgencyId() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).all('stocks').getList().then(function (datas) {
				return _.map(datas, function (data) {
					return new Stock(data)
				})
			})
		},
		
		// POST: /agencies/{agency_id}/stocks
		save: function(stock, agencyId) {
			if (!stock || !agencyId) {
				throw 'StockService::save() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).all('stocks').post(stock);
		},
		
		bulkSave : function(stocks, agencyId) {
			if (!stocks || !agencyId) {
				throw 'StockService::bulkSave() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).all('stocks').post(stocks);
		}
	}

	return StockService
}])